import React, { useState, Fragment, useEffect, useContext } from "react";
import { Alert, NotificationManager, Section, Spinner } from "design-react-kit";
import { useSignIn, useSignOut } from "react-auth-kit";
import { useNavigate, useParams } from "react-router-dom";
import { sendApiRequest } from "../../services/Base/base-service";

import SubNavigation from "../../components/Header/SubNavigation";
import PDFSidebar from "../../components/PfdSidebar";
import UserContext from "../../store/user-context";
import NotificationEditForm from "../../components/Forms/NotificationEditForm";

import secureLocalStorage from "react-secure-storage";
import DocumentTypeEnum from "../../helpers/Enums/DocumentTypeEnum";

const NotificationEdit = () => {
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isVerified, setIsVerified] = useState(false);
  const [notificationData, setNotificationData] = useState(null);
  const [files, setFiles] = useState([]);
  const [invalidProperties, setInvalidProperties] = useState(null);

  const edit = secureLocalStorage.getItem("edit");

  const signIn = useSignIn();
  const signOut = useSignOut();
  const navigate = useNavigate();

  const params = useParams();
  const notificationId = params?.id;

  const userContext = useContext(UserContext);

  const hasPaymentNotice = !files.every(
    (f) => f.documentType !== DocumentTypeEnum.PaymentNotice
  );

  useEffect(() => {
    if (edit) {
      getInvalidNotificationDataHandler();
    } else {
      getNotificationDataHandler();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [edit]);

  const getInvalidNotificationDataHandler = () => {
    setError(null);
    setIsLoading(true);
    sendApiRequest(
      `Notification/getInvalidNotificationData/?invalidNotificationId=${notificationId}`,
      "GET",
      true,
      null,
      signIn,
      signOut,
      navigate,
      null,
      userContext
    ).then((response) => {
      if (response !== undefined) {
        if (response.errors !== null) {
          setError(response.errors);
          setIsLoading(false);
        } else {
          if (response.data.notificationFiles !== null) {
            let files = [];
            response.data.notificationFiles.map((file) => {
              return files.push({
                name: file.fileName,
                fileContent: file.fileContent,
                documentType: file.documentType,
              });
            });

            setFiles(files);
            setNotificationData(response.data.notificationData);
            setInvalidProperties(response.data.invalidProperties);
            setIsLoading(false);
          }
        }
      }
    });
  };

  const getNotificationDataHandler = () => {
    setError(null);
    setIsLoading(true);
    sendApiRequest(
      `Notification/getNotificationData/?notificationId=${notificationId}`,
      "GET",
      true,
      null,
      signIn,
      signOut,
      navigate,
      null,
      userContext
    ).then((response) => {
      if (response !== undefined) {
        if (response.errors !== null) {
          setError(response.errors);
          setIsLoading(false);
        } else {
          if (response.data.notificationFiles !== null) {
            let files = [];
            response.data.notificationFiles.map((file) => {
              return files.push({
                name: file.fileName,
                fileContent: file.fileContent,
                documentType: file.documentType,
              });
            });

            setFiles(files);
            setNotificationData(response.data.notificationData);
            setIsLoading(false);
          }
        }
      }
    });
  };

  return (
    <Fragment>
      <SubNavigation
        page="edit"
        notificationData={notificationData}
        setInvalidProperties={setInvalidProperties}
        isVerified={isVerified}
        setError={setError}
        setIsLoading={setIsLoading}
        files={files}
        edit={edit}
      />
      <Section>
        <h3 className="mb-5">
          {edit ? "Validazione dati acquisiti" : "Visualizza dati validati"}
        </h3>
        {error !== null && error.length !== undefined && !isLoading && (
          <div colSpan={12}>
            <Alert className="w-50 mx-auto" color="danger">
              {error.map((item) => (
                <p key={item}>{item}</p>
              ))}
            </Alert>
          </div>
        )}
        {edit && (
          <Alert color="info" id="edit-alert">
            La sezione di modifica consente di verificare l'accuratezza
            dell'elaborazione dei documenti, effettuata dall'intelligenza
            artificiale. La colonna di sinistra mostra i documenti in formato
            PDF, mentre sulla colonna di destra è possibile visualizzare e
            modificare i campi interpretati erroneamente. Qualora fossero
            riscontrati errori di interpretazione, sarà possibile correggere
            facilmente le informazioni errate attraverso i campi di input
            forniti. Questa sezione consente di garantire che tutti i documenti
            siano completi e precisi prima di procedere con le successive
            attività.
          </Alert>
        )}
        {!edit && (
          <Alert color="info" id="edit-alert">
            La sezione di consultazione consente di verificare l'accuratezza
            dell'elaborazione dei documenti effettuata dall'intelligenza
            artificiale. La colonna di sinistra mostra i documenti in formato
            PDF, mentre sulla colonna di destra è possibile visualizzare
            puntualmente quali sono i valori acquisiti che saranno poi
            utilizzati per la compilazione e trasmissione vera e propria della
            richiesta di notifica.
          </Alert>
        )}
        <div className="position-relative">
          {isLoading && (
            <p style={{ height: "50px" }}>
              <Spinner double active />
            </p>
          )}
        </div>
        {files.length > 0 && (
          <div className="content d-flex">
            <PDFSidebar files={files} />
            <NotificationEditForm
              notificationData={notificationData}
              setNotificationData={setNotificationData}
              setIsVerified={setIsVerified}
              invalidProperties={invalidProperties}
              hasPaymentNotice={hasPaymentNotice}
            />
          </div>
        )}

        {error === null && files.length === 0 && !isLoading && (
          <div colSpan={12}>
            <Alert className="w-50 mx-auto" color="info">
              Nessun risultato trovato!
            </Alert>
          </div>
        )}
        <div>
          <NotificationManager
            containerId="esempio-avanzato"
            fix="right"
            closeOnClick={true}
            state="success"
            duration={30000}
          />
        </div>
      </Section>
    </Fragment>
  );
};

export default NotificationEdit;
